/**
 * Created by Макс on 16.10.2017.
 */
export class SingInForm {
  ValidEmail: boolean = true;
  remember: boolean = true;
  password:string;
  login:string;

}



// WEBPACK FOOTER //
// ./src/app/components/app/class/sing-in-form.ts